export const initialData = [
    {
        id: 0,
        scene: "Maria is sitting at the cafe, waiting for Jackson.",
        sceneNumber: 1,
        chapter: 1,
        setting: "Coffee shop near house. Afternoon. Quiet. Only two other people in the cafe.",
        sceneDetails: "Maria ordered a cup of coffee that she hasn't touched. She's not sure why she even ordered it.",
        sceneReasoning: "Character introduction",
        needsEditing: false,
    },
    {
        id: 1,
        scene: "",
        sceneNumber: 2,
        chapter: 1,
        setting: "",
        sceneDetails: "",
        sceneReasoning: "",
        needsEditing: true,
    }
]

export const fullTemplate =  [
    {
        id: 0,
        scene: "Maria is sitting at the cafe, waiting for Jackson.",
        sceneNumber: 1,
        chapter: 1,
        setting: "Coffee shop near house. Afternoon. Quiet. Only two other people in the cafe.",
        sceneDetails: "Maria ordered a cup of coffee that she hasn't touched. She's not sure why she even ordered it.",
        sceneReasoning: "Character introduction",
        needsEditing: false,
    },
    {
        id: 1,
        scene: "Jackson arrives late, looking flustered and apologetic.",
        sceneNumber: 2,
        chapter: 1,
        setting: "Same cafe, now bustling with late afternoon patrons.",
        sceneDetails: "He rushes in, nearly spilling his drink, and immediately starts explaining his delay.",
        sceneReasoning: "Establishing conflict and character dynamics.",
        needsEditing: false,
    },
    {
        id: 2,
        scene: "A heated argument breaks out between Maria and Jackson.",
        sceneNumber: 3,
        chapter: 1,
        setting: "The cafe, tension rising as other customers watch.",
        sceneDetails: "Maria feels betrayed as Jackson accuses her of being overly dramatic.",
        sceneReasoning: "Developing the relationship and introducing conflict.",
        needsEditing: true,
    },
    {
        id: 3,
        scene: "Maria storms out of the cafe, leaving Jackson behind.",
        sceneNumber: 4,
        chapter: 1,
        setting: "Outside the cafe, the evening sun sets.",
        sceneDetails: "She walks briskly, tears in her eyes, as the weight of their argument sinks in.",
        sceneReasoning: "Showcasing emotional impact and character growth.",
        needsEditing: false,
    },
    {
        id: 4,
        scene: "Jackson follows Maria, trying to catch up.",
        sceneNumber: 5,
        chapter: 1,
        setting: "City streets, the air cool and filled with tension.",
        sceneDetails: "He calls her name, desperate to explain himself.",
        sceneReasoning: "Highlighting the consequences of their conflict.",
        needsEditing: false,
    },
    {
        id: 5,
        scene: "Maria reaches a park, taking a moment to gather her thoughts.",
        sceneNumber: 6,
        chapter: 1,
        setting: "A small park with benches and a fountain, surrounded by trees.",
        sceneDetails: "She sits on a bench, replaying their argument in her mind.",
        sceneReasoning: "Providing insight into Maria's internal struggle.",
        needsEditing: true,
    },
    {
        id: 6,
        scene: "Jackson finally catches up and sits beside her.",
        sceneNumber: 7,
        chapter: 1,
        setting: "The same park, now quiet except for distant sounds.",
        sceneDetails: "He breathes heavily, unsure of how to start the conversation.",
        sceneReasoning: "Building tension and anticipation for resolution.",
        needsEditing: false,
    },
    {
        id: 7,
        scene: "Maria and Jackson begin to talk, opening up about their feelings.",
        sceneNumber: 8,
        chapter: 1,
        setting: "The park, twilight settling in around them.",
        sceneDetails: "They share their vulnerabilities, slowly mending their relationship.",
        sceneReasoning: "Fostering character development and resolution.",
        needsEditing: false,
    }
];


export const urlConfigs = {
    website: 'https://www.thisisnichie.today/',
    newsletter: 'https://nichie.substack.com/',
    kofi: 'https://ko-fi.com/thisisnichie'
}